import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
import moment from 'moment';
import { Loader } from '@sdir/sds';
import { ErrorWithTrace } from '@sdir/blueprint.aps/lib/components';
import { paymentApi } from '../../../httpclient';
import { CardRow, Card } from '../../Atoms';

const getArticleInfoApiCall = paymentApi?.v1PaymentGetarticleinfoQueryPost?.bind(paymentApi);

const PaymentSummaryCard: React.FC<{ certificateCode: string }> = ({ certificateCode }) => {
  const intl = useIntl();

  const {
    errorObject: articleInfoError,
    result: articleInfoResult,
    loading: articleInfoLoading,
    callApi: callArticleInfo,
  } = useApi({ apiFunction: getArticleInfoApiCall });

  useEffect(() => {
    callArticleInfo({
      certificateCode,
      chargeDate: moment().format(),
    });
  }, [callArticleInfo, certificateCode]);

  return (
    <Card heading={intl.formatMessage({ id: 'newapp.steps.payment' })}>
      {articleInfoLoading ? (
        <Loader />
      ) : (
        <>
          <CardRow
            label={intl.formatMessage({
              id: 'payment.summary.charge',
            })}
          >
            {articleInfoResult?.name || '-'}
          </CardRow>
          <CardRow
            label={intl.formatMessage({
              id: 'payment.summary.amount',
            })}
          >
            {`${articleInfoResult?.amount || '-'} nok.`}
          </CardRow>
          {articleInfoError && (
            <ErrorWithTrace
              error={articleInfoError}
              trace={articleInfoError?.response?.headers?.traceresponse}
            />
          )}
        </>
      )}
    </Card>
  );
};

export default PaymentSummaryCard;
